export const AnalyticsEvent = {
	EVENT_DOWNLOAD:  'event_download',
	MOMENT_DOWNLOAD: 'moment_download',
	EVENT_SHARE:     'event_share',
};
